<script setup>
import RichTextComponent from './RichTextComponent.vue'
</script>
<template>
  <div class="footer">
    <div class="container-lg">
      <div class="row mb-20-px">
        <div class="col-12 col-sm-auto text-center text-sm-start">
          <img
            class="logo-app mt-3"
            src="@/assets/images/logo-footer.webp"
            alt=""
            loading="lazy"
            decoding="async"
          />
        </div>
        <!-- <div class="col-12 col-sm">
          <div
            class="d-flex wrap justify-content-center mt-3 justify-content-sm-end gap-3 gap-lg-5 align-items-sm-end"
          >
            <img
              height="42px"
              src="@/assets/images/EU-logo1.svg"
              alt="logo-eu"
              loading="lazy"
              decoding="async"
            />
            <img
              height="42px"
              src="@/assets/images/EU-logo2.svg"
              alt="logo-eccc"
              loading="lazy"
              decoding="async"
            />
            <img
              height="50px"
              src="@/assets/images/EU-logo3_footer.webp"
              alt="logo-dnsc"
              loading="lazy"
              decoding="async"
              class="logo-dnsc"
            />
          </div>
        </div> -->
      </div>
      <div class="row">
        <div class="col pe-lg-5">
          <h6 class="color-white mt-2 mt-lg-4 mt-sm-0">
            <RichTextComponent :text="dataSquidex?.data?.text?.textContent"></RichTextComponent>
            <!-- <RichTextComponent :text="dataSquidex"></RichTextComponent> -->
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFooterQuery } from '@/graphs/footerGraph'
export default {
  name: '',
  data() {
    return {
      dataSquidex: null,
      loaders: {},
    }
  },

  methods: {
    async GetFooterItems() {
      const lang = this.$utils.getCookie()
      const query = getFooterQuery(lang)
      this.loaders.isSquidexDataLoaded = false
      await this.$axios
        .post(`/api/Squidex/postGraphQLAsync`, query)
        .then((response) => {
          const raw = response.data?.data?.findFooterSingleton
          //remove language

          let cleanData = this.$utils.removeLocaleDeep(raw, lang)
          cleanData = this.$utils.transformImageFields(cleanData)
          this.dataSquidex = cleanData
          this.loaders.isSquidexDataLoaded = true
        })
        .catch((error) => {
          this.loaders.isSquidexDataLoaded = true
          this.$utils.ToastNotifySomethingWentWrong()
        })
    },
  },
  created() {
    this.GetFooterItems()
  },
}
</script>
<style scoped>
.footer-description {
  font-size: 15px;
  color: white;
}

.footer {
  background-color: var(--neutral-900);
  min-height: 136px;
  padding: 20px 0px 20px 0px;
  width: 100%;
}

img:not(.logo-app):not(.logo-dnsc) {
  filter: invert(99%) sepia(1%) saturate(521%) hue-rotate(71deg) brightness(114%) contrast(112%);
}
@media (max-width: 576px) {
  h6 {
    font-size: 12px;
    text-align: center;
  }
}

.logo-app {
  width: 133px;
}

.logo-dnsc {
  filter: brightness(0) invert(1);
}
</style>
